var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center"},[_c('div',{staticClass:"relative"},[_c('img',{staticClass:"defWidth",attrs:{"src":require("@/assets/images/map/basemap.png"),"alt":""}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }